import { render, staticRenderFns } from "./warehouse-inventory-traceability-modal.vue?vue&type=template&id=a2e85d7a"
import script from "./warehouse-inventory-traceability-modal.vue?vue&type=script&lang=js"
export * from "./warehouse-inventory-traceability-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports